import { FC, ReactNode, useEffect, useState } from 'react';
import { KalenderhändelsearkivResponse } from '../../types/pages';
import styles from './Kalender.module.css';
import { Heading } from '@kpa/kul';
import React from 'react';
import KalenderHändelse from './KalenderHändelse';
import { konverteraKalenderHändelserTillYearMap, YearMap } from './konverteraDatumTillMap';

type KalenderProps = {
  response: KalenderhändelsearkivResponse;
};

const Kalender: FC<KalenderProps> = ({ response }): ReactNode => {
  const [yearMap, setYearMap] = useState<YearMap>();

  useEffect(() => {
    const yearMap = konverteraKalenderHändelserTillYearMap(response.kalenderhändelser);
    setYearMap(yearMap);
  }, [response]);

  function getKortformMånad(månadNummer: number): string {
    const månader = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
    return månader[månadNummer - 1]; // -1 eftersom månaderna är 0-indexerade i arrayen
  }

  return (
    <>
      {response.rubrik && <Heading headingLevel={1} className={styles.header}>{response.rubrik}</Heading>}
      <div className={styles.container}>
        {yearMap !== undefined && Array.from(yearMap.entries()).map(([year, monthMaps]) => (
          <React.Fragment key={year}>
            <Heading headingLevel={2} className={styles.header} key={year}>{year}</Heading>
            {
              monthMaps.map((monthMap, index) => (
                <React.Fragment key={index}>
                  {Array.from(monthMap.entries()).map(([month, händelser]) => (
                    <React.Fragment key={month}>
                      <Heading headingLevel={3} className={styles.subheader}>{getKortformMånad(month)}</Heading>
                      <ul className={styles.ul}>
                        {händelser.map(händelse => (
                          <li className={styles.li} key={händelse.id}>
                            <KalenderHändelse händelse={händelse}></KalenderHändelse>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))
            }
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default Kalender;
